function getImages(product) {

  const variants = product.variants
  const images = product.images

  let variant_options = {}

  // build a variant options reference - for each variant, get the options used

  for (const variant of variants) {
      variant_options[variant.id] = {}

      if (variant.option1) {
          variant_options[variant.id]['option1'] = variant.option1
      }

      if (variant.option2) {
          variant_options[variant.id]['option2'] = variant.option2
      }
      
      if (variant.option3) {
          variant_options[variant.id]['option3'] = variant.option3
      }
  }

  let all_images = []
  let variant_ids = []


  for (const image of images) {

      if (image.variant_ids.length > 0) {
          variant_ids = image.variant_ids
      } else {
          variant_ids = [ variants[0].id ]
      }

      for (const variant_id of variant_ids) {
          const image_obj = {
              'src': image.src,
              'alt': image.alt,
              'pos': image.position,
              'variant_id': variant_id,
              'option1': variant_options[variant_id].option1,
              'option2': variant_options[variant_id].option2,
              'option3': variant_options[variant_id].option3
          }
          all_images.push(image_obj)
      }
      
  }

  return all_images;

}

// Product variant selection and image management

// Product variant selection and image management

(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
      module.exports = factory();
  } else {
      root.ImageZoom = factory();
  }
}(this, function () {
  /**
   * @param {Object} container DOM element, which contains an image to be zoomed (required)
   * @param {Object} options js-image-zoom options (required)
   * **width** (number) - width of the source image (optional)
   * **height** (number) - height of the source image (optional).
   * **zoomWidth** (number) - width of the zoomed image. Zoomed image height equals source image height (optional)
   * **img** (string) - url of the source image. Provided if container does not contain img element as a tag (optional)
   * **scale** (number) - zoom scale. if not provided, scale is calculated as natural image size / image size, provided in params (optional if zoomWidth param is provided)
   * **offset** (object) - {vertical: number, horizontal: number}. Zoomed image offset (optional)
   * **zoomContainer** (node) - DOM node reference where zoomedImage will be appended to (default to the container element of image)
   * **zoomStyle** (string) - custom style applied to the zoomed image (i.e. 'opacity: 0.1;background-color: white;')
   * **zoomPosition** (string) - position of zoomed image. It can be:  `top`, `left`, `bottom`, `original` or the default `right`.
   * **zoomLensStyle** (string) custom style applied to to zoom lents (i.e. 'opacity: 0.1;background-color: white;')
   */
  return function ImageZoom(container, opts) {
      "use strict";
      var options = opts;
      if (!container) {
          return;
      }
      var data = {
          sourceImg: {
              element: null,
              width: 0,
              height: 0,
              naturalWidth: 0,
              naturalHeight: 0
          },
          zoomedImgOffset: {
              vertical: 0,
              horizontal: 0
          },
          zoomedImg: {
              element: null,
              width: 0,
              height: 0
          },
          zoomLens: {
              element: null,
              width: 0,
              height: 0
          }
      };

      var div = document.createElement('div');
      var lensDiv = document.createElement('div');
      var scaleX;
      var scaleY;
      var offset;
      data.zoomedImgOffset = {
          vertical: options.offset && options.offset.vertical ? options.offset.vertical : 0,
          horizontal: options.offset && options.offset.horizontal ? options.offset.horizontal : 0
      };
      data.zoomPosition = options.zoomPosition || 'right';
      data.zoomContainer = (options.zoomContainer) ? options.zoomContainer : container;
      function getOffset(el) {
          if (el) {
              var elRect = el.getBoundingClientRect();
              return {left: elRect.left, top: elRect.top};
          }
          return {left: 0, top: 0};
      }

      function leftLimit(min) {
          return options.width - min;
      }

      function topLimit(min) {
          return options.height - min;
      }

      function getValue(val, min, max) {
          if (val < min) {
              return min;
          }
          if (val > max) {
              return max;
          }
          return val;
      }

      function getPosition(v, min, max) {
          var value = getValue(v, min, max);
          return value - min;
      }

      function zoomLensLeft(left) {
          var leftMin = data.zoomLens.width / 2;
          return getPosition(left, leftMin, leftLimit(leftMin));
      }

      function zoomLensTop(top) {
          var topMin = data.zoomLens.height / 2;
          return getPosition(top, topMin, topLimit(topMin));
      }

      function setZoomedImgSize(options, data) {
          if (options.scale) {
              data.zoomedImg.element.style.width = options.width * options.scale + 'px';
              data.zoomedImg.element.style.height = options.height * options.scale + 'px';
          } else if (options.zoomWidth) {
              data.zoomedImg.element.style.width = options.zoomWidth + 'px';
              data.zoomedImg.element.style.height = data.sourceImg.element.style.height;
          } else {
              data.zoomedImg.element.style.width = '100%';
              data.zoomedImg.element.style.height = '100%';
          }
      }

      function onSourceImgLoad() {
          // CRITICAL: Always use natural dimensions for calculations, never rendered dimensions
          data.sourceImg.naturalWidth = data.sourceImg.element.naturalWidth;
          data.sourceImg.naturalHeight = data.sourceImg.element.naturalHeight;
          
          // CRITICAL: For responsive images, always use percentage widths, never pixel widths
          if (options.fillContainer) {
              if (window.innerWidth < 768) {
                  data.sourceImg.element.style.setProperty('width', '100%', 'important');
              } else {
                  data.sourceImg.element.style.width = '';
              }
              data.sourceImg.element.style.height = 'auto';
              data.sourceImg.element.style.maxWidth = '100%';
              
              // Get container dimensions for zoom calculations, but use natural dimensions for scale
              const containerRect = container.getBoundingClientRect();
              // Use natural dimensions for scale calculations, not rendered dimensions
              options.width = data.sourceImg.naturalWidth;
              options.height = data.sourceImg.naturalHeight;
          } else {
              // Only use pixel values if explicitly provided and fillContainer is false
              options.height = options.height || data.sourceImg.naturalHeight;
              options.width = options.width || data.sourceImg.naturalWidth;
              data.sourceImg.element.style.height = options.height + 'px';
              data.sourceImg.element.style.width = options.width + 'px';
          }

          setZoomedImgSize(options, data);

          data.zoomedImg.element.style.backgroundSize = data.sourceImg.naturalWidth + 'px ' + data.sourceImg.naturalHeight + 'px';

          if (options.zoomStyle) {
              data.zoomedImg.element.style.cssText += options.zoomStyle;
          }
          if (options.zoomLensStyle) {
              data.zoomLens.element.style.cssText += options.zoomLensStyle;
          } else {
              data.zoomLens.element.style.background = 'white';
              data.zoomLens.element.style.opacity = '0.4';
          }

          // CRITICAL: For fillContainer mode, calculate scale based on container size, not fixed pixel width
          if (options.fillContainer) {
              // Get actual container dimensions for scale calculation
              const containerRect = container.getBoundingClientRect();
              const containerWidth = containerRect.width || data.sourceImg.naturalWidth;
              const containerHeight = containerRect.height || data.sourceImg.naturalHeight;
              scaleX = data.sourceImg.naturalWidth / containerWidth;
              scaleY = data.sourceImg.naturalHeight / containerHeight;
          } else {
              // Use provided width/height for scale calculation
              scaleX = data.sourceImg.naturalWidth / options.width;
              scaleY = data.sourceImg.naturalHeight / options.height;
          }
          offset = getOffset(data.sourceImg.element);

          // set zoomLens dimensions
          // if custom scale is set
          if (options.scale) {
              data.zoomLens.width = options.width / (data.sourceImg.naturalWidth / (options.width * options.scale));
              data.zoomLens.height = options.height / (data.sourceImg.naturalHeight / (options.height * options.scale));
          }

          // else if zoomWidth is set
          else if (options.zoomWidth) {
              data.zoomLens.width = options.zoomWidth / scaleX;
              data.zoomLens.height = options.height / scaleY;
          }

          // else read from the zoomedImg
          else {
              data.zoomedImg.element.style.display = 'block';
              data.zoomLens.width = data.zoomedImg.element.clientWidth / scaleX;
              data.zoomLens.height = data.zoomedImg.element.clientHeight / scaleY;
              data.zoomedImg.element.style.display = 'none';
          }

          data.zoomLens.element.style.position = 'absolute';
          data.zoomLens.element.style.width = data.zoomLens.width + 'px';
          data.zoomLens.element.style.height = data.zoomLens.height + 'px';
          data.zoomLens.element.pointerEvents = 'none';
      }

      function setup() {
          // create sourceImg element
          if (options.img) {
              var img = document.createElement('img');
              img.src = options.img;
              data.sourceImg.element = container.appendChild(img);
          }

          // or get sourceImg element from specified container
          else {
              if (container.children.length > 0) {
              data.sourceImg.element = container.children[0];

              // if sourceImg is not an img (might be a picture element), try to find one
                  if (data.sourceImg.element && data.sourceImg.element.nodeName !== "IMG") {
                  data.sourceImg.element = data.sourceImg.element.querySelector('img');
                  }
              } else {
                  // No children found, try to find img directly in container
                  data.sourceImg.element = container.querySelector('img');
              }
          }

          options = options || {};
          container.style.position = 'relative';
          
          // CRITICAL: For responsive images, always use percentage widths, never set fixed pixel widths
          if (options.fillContainer) {
              if (window.innerWidth < 768) {
                  data.sourceImg.element.style.setProperty('width', '100%', 'important');
              } else {
                  data.sourceImg.element.style.removeProperty('width');
              }
              data.sourceImg.element.style.removeProperty('max-width');
              data.sourceImg.element.style.setProperty('height', 'auto', 'important');
              data.sourceImg.element.style.setProperty('max-width', '100%', 'important');
          } else {
              // Only use pixel values if explicitly provided and fillContainer is false
              data.sourceImg.element.style.width = options.width ? options.width + 'px' : 'auto';
              data.sourceImg.element.style.height = 'auto'; // CRITICAL: Always use auto for responsive scaling
          }

          data.zoomLens.element = container.appendChild(lensDiv);
          data.zoomLens.element.style.display = 'none';
          data.zoomLens.element.style.zIndex = '30';
          data.zoomLens.element.classList.add('js-image-zoom__zoomed-area');

          data.zoomedImg.element = data.zoomContainer.appendChild(div);
          data.zoomedImg.element.classList.add('js-image-zoom__zoomed-image');
          data.zoomedImg.element.style.backgroundImage = "url('" + data.sourceImg.element.src + "')";
          data.zoomedImg.element.style.backgroundRepeat = 'no-repeat';
          data.zoomedImg.element.style.display = 'none';
          data.zoomedImg.element.style.zIndex = '30';

          switch (data.zoomPosition) {
              case 'left':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical + 'px';
                  data.zoomedImg.element.style.left = data.zoomedImgOffset.horizontal - (data.zoomedImgOffset.horizontal * 2) + 'px';
                  data.zoomedImg.element.style.transform = 'translateX(-100%)';
                  break;

              case 'top':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical - (data.zoomedImgOffset.vertical * 2) + 'px';
                  data.zoomedImg.element.style.left = 'calc(50% + ' + data.zoomedImgOffset.horizontal + 'px)';
                  data.zoomedImg.element.style.transform = 'translate3d(-50%, -100%, 0)';
                  break;

              case 'bottom':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.bottom = data.zoomedImgOffset.vertical - (data.zoomedImgOffset.vertical * 2) + 'px';
                  data.zoomedImg.element.style.left = 'calc(50% + ' + data.zoomedImgOffset.horizontal + 'px)';
                  data.zoomedImg.element.style.transform = 'translate3d(-50%, 100%, 0)';
                  break;

              case 'original':
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = '0px';
                  data.zoomedImg.element.style.left = '0px';
                  break;

              // Right Position
              default:
                  data.zoomedImg.element.style.position = 'absolute';
                  data.zoomedImg.element.style.top = data.zoomedImgOffset.vertical + 'px';
                  data.zoomedImg.element.style.right = data.zoomedImgOffset.horizontal - (data.zoomedImgOffset.horizontal * 2) + 'px';
                  data.zoomedImg.element.style.transform = 'translateX(100%)';
                  break;
          }


          // setup event listeners
          container.addEventListener('mousemove', events, false);
          container.addEventListener('mouseenter', events, false);
          container.addEventListener('mouseleave', events, false);
          data.zoomLens.element.addEventListener('mouseenter', events, false);
          data.zoomLens.element.addEventListener('mouseleave', events, false);
          window.addEventListener('scroll', events, false);

          return data;
      }

      function kill() {

          // remove event listeners
          container.removeEventListener('mousemove', events, false);
          container.removeEventListener('mouseenter', events, false);
          container.removeEventListener('mouseleave', events, false);
          data.zoomLens.element.removeEventListener('mouseenter', events, false);
          data.zoomLens.element.removeEventListener('mouseleave', events, false);
          window.removeEventListener('scroll', events, false);

          // remove dom nodes
          if (data.zoomLens && data.zoomedImg) {
              container.removeChild(data.zoomLens.element);
              data.zoomContainer.removeChild(data.zoomedImg.element);
          }

          if (options.img) {
              container.removeChild(data.sourceImg.element);
          } else {
              data.sourceImg.element.style.width = '';
              data.sourceImg.element.style.height = '';
          }

          return data;
      }

      var events = {
          handleEvent: function (event) {
              switch (event.type) {
                  case 'mousemove':
                      return this.handleMouseMove(event);
                  case 'mouseenter':
                      return this.handleMouseEnter(event);
                  case 'mouseleave':
                      return this.handleMouseLeave(event);
                  case 'scroll':
                      return this.handleScroll(event);
              }
          },
          handleMouseMove: function (event) {
              var offsetX;
              var offsetY;
              var backgroundTop;
              var backgroundRight;
              var backgroundPosition;
              if (offset) {
                  offsetX = zoomLensLeft(event.clientX - offset.left);
                  offsetY = zoomLensTop(event.clientY - offset.top);
                  backgroundTop = offsetX * scaleX;
                  backgroundRight = offsetY * scaleY;
                  backgroundPosition = '-' + backgroundTop + 'px ' + '-' + backgroundRight + 'px';
                  data.zoomedImg.element.style.backgroundPosition = backgroundPosition;
                  data.zoomLens.element.style.cssText += 'transform:' + 'translate(' + offsetX + 'px,' + offsetY +'px);display: block;left:0px;top:0px;'

              }
          },
          handleMouseEnter: function () {
              data.zoomedImg.element.style.display = 'block';
              data.zoomLens.element.style.display = 'block';

          },
          handleMouseLeave: function () {
              data.zoomedImg.element.style.display = 'none';
              data.zoomLens.element.style.display = 'none';
          },
          handleScroll: function () {
              offset = getOffset(data.sourceImg.element);
          }
      };

      // Setup/Initialize library
      setup();

      if (data.sourceImg.element.complete) {
          onSourceImgLoad();
      } else {
          data.sourceImg.element.onload = onSourceImgLoad;
      }

      return {
          setup: function () {
              setup();
          },
          kill: function () {
              kill();
          },
          _getInstanceInfo: function () {
              return {
                  setup: setup,
                  kill: kill,
                  onSourceImgLoad: onSourceImgLoad,
                  data: data,
                  options: options
              }
          }
      }
  }
}));

const radios = document.querySelectorAll("[data-option-radio]");
const selects = document.querySelectorAll("[data-option-select]");
const main = document.querySelector("[data-option-main]");

const selectors = document.querySelectorAll("[data-option-selector]")

let selected = [];

const add_to_cart_button = document.querySelector(".js-add-to-cart");
const sold_out = document.querySelector(".js-sold-out");

// Function to get current variants JSON (re-reads from DOM each time)
function getVariantsJson() {
  const variantsElement = document.querySelector(".js-variants-json");
  if (!variantsElement) {
    return [];
  }
  try {
    return JSON.parse(variantsElement.innerHTML);
  } catch (e) {
    console.error('Error parsing variants JSON:', e);
    return [];
  }
}

// Expose on window so product.liquid can access it
window.getVariantsJson = getVariantsJson;

// Initialize variants_json (will be re-read when product changes)
let variants_json = getVariantsJson();

// Function to refresh variants JSON (call this when product changes)
window.refreshVariantsJson = function() {
  variants_json = getVariantsJson();
};

async function getProductImages() {

  const el = document.querySelector('.js-product')
  const handle = el.dataset.handle

  // get the product data, using the values
  const product = await fetch(`/products/${handle}.json`)
    .then(response => response.json())
    .then(data => { return data.product });
  
  return getImages(product)
}

// Store images globally
let images = [];

  // Helper function to reset size selection when color changes
  function resetSizeForColor() {
    // Guard: skip during/shortly after seamless update — the template code manages size selection
    if (window.isSeamlessUpdateInProgress) return false;
    if (window._seamlessUpdateCompleteTime && (Date.now() - window._seamlessUpdateCompleteTime < 2000)) return false;

    // Get the selected color (position 1)
    const colorSelector = document.querySelector('[data-option-position="1"][data-option-selector]:checked');
    if (!colorSelector) {
      return false; // No color selected
    }
    
    const selectedColor = colorSelector.value;
    
    // Get currently selected size (position 2)
    const currentSizeSelector = document.querySelector('[data-option-position="2"][data-option-selector]:checked');
    
    // Check if current size is available for the new color
    if (currentSizeSelector) {
      const currentSize = currentSizeSelector.value;
      const testVariant = variants_json.find(v => {
        // Try using option1/option2 first (more reliable)
        if (v.option1 && v.option2) {
          return v.option1 === selectedColor && v.option2 === currentSize;
        }
        // Fallback to title parsing
        const titleParts = v.title.split(' / ');
        return titleParts[0] === selectedColor && titleParts[1] === currentSize;
      });
      
      if (testVariant) {
        return false; // Size is valid, no need to reset
      }
    }
    
    const availableSizes = [];
    
    // Find all sizes available for this color
    variants_json.forEach(v => {
      let sizeValue = null;
      // Try using option1/option2 first (more reliable)
      if (v.option1 && v.option2) {
        if (v.option1 === selectedColor) {
          sizeValue = v.option2;
        }
      } else {
        // Fallback to title parsing
        const titleParts = v.title.split(' / ');
        if (titleParts[0] === selectedColor && titleParts[1]) {
          sizeValue = titleParts[1];
        }
      }
      
      if (sizeValue && !availableSizes.includes(sizeValue)) {
        availableSizes.push(sizeValue);
      }
    });
    
    // Uncheck all size radios
    document.querySelectorAll('[data-option-position="2"][data-option-selector]').forEach(radio => {
      radio.checked = false;
    });
    
    // Select the first available size
    if (availableSizes.length > 0) {
      const firstSize = availableSizes[0];
      const firstSizeRadio = document.querySelector('[data-option-position="2"][data-option-selector][value="' + firstSize + '"]');
      if (firstSizeRadio) {
        firstSizeRadio.checked = true;
        return true; // Size was reset
      }
    }
    
    return false;
  }

  for (const selector of selectors) {
    selector.addEventListener('change', function() {
      const position = this.getAttribute('data-option-position');
      if (position === '1') {
        // Reset size selection if needed
        const sizeWasReset = resetSizeForColor();
        if (sizeWasReset) {
          // Trigger change event on the newly selected size radio
          const newSizeRadio = document.querySelector('[data-option-position="2"][data-option-selector]:checked');
          if (newSizeRadio) {
            // Use a small delay to ensure the color change is processed first
            setTimeout(() => {
              newSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }, 10);
          }
        }
      }
      
      const selected_variant = window.getSelectedVariant();
      
      if (selected_variant) {
        window.updateSelection(selected_variant);
      } else {
        if (position === '1') {
          const colorValue = this.value;
          const firstVariantForColor = variants_json.find(v => {
            // Try using option1 first (more reliable)
            if (v.option1) {
              return v.option1 === colorValue;
            }
            // Fallback to title parsing
            const titleParts = v.title.split(' / ');
            return titleParts[0] === colorValue;
          });
          if (firstVariantForColor) {
            const mainSelect = document.querySelector("[data-option-main]");
            if (mainSelect) {
              mainSelect.value = firstVariantForColor.id;
            }
            if (main) {
              main.value = firstVariantForColor.id;
            }
            window.updateSelection(firstVariantForColor);
          }
        }
      }
    }, false); // Use bubble phase, not capture
  }
  
  // Attach change listeners to all option selector radios
  // Exposed on window so it can be re-called after seamless product updates
  window.attachProductOptionListeners = function() {
    document.querySelectorAll('[data-option-selector]').forEach(function(radio) {
      if (!radio.hasAttribute('data-listener-attached')) {
        radio.setAttribute('data-listener-attached', 'true');
        radio.addEventListener('change', function() {
          const position = this.getAttribute('data-option-position');
          if (position === '1') {
            const colorHandle = this.getAttribute('data-color-product-handle');
            const jsProduct = document.querySelector('.js-product');
            const currentProductHandle = jsProduct && jsProduct.dataset ? jsProduct.dataset.handle : null;
            
            if (colorHandle && colorHandle !== currentProductHandle) {
              if (window.isSeamlessUpdateInProgress) return;
              const colorUrl = this.getAttribute('data-color-url') || '/products/' + colorHandle;
              if (typeof window.updateProductSeamlessly === 'function') {
                window.isSeamlessUpdateInProgress = true;
                window.updateProductSeamlessly(colorUrl, colorHandle);
              } else {
                window.location.href = colorUrl;
              }
              return;
            }
            
            const sizeWasReset = resetSizeForColor();
            if (sizeWasReset) {
              const newSizeRadio = document.querySelector('[data-option-position="2"][data-option-selector]:checked');
              if (newSizeRadio) {
                setTimeout(() => {
                  newSizeRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }, 10);
              }
            }
          }
          
          const selected_variant = window.getSelectedVariant();
          if (selected_variant && typeof window.updateSelection === 'function') {
            window.updateSelection(selected_variant);
          } else if (position === '1') {
            const colorValue = this.value;
            const firstVariantForColor = variants_json.find(v => {
              if (v.option1) {
                return v.option1 === colorValue;
              }
              const titleParts = v.title.split(' / ');
              return titleParts[0] === colorValue;
            });
            if (firstVariantForColor && typeof window.updateSelection === 'function') {
              const mainSelect = document.querySelector("[data-option-main]");
              if (mainSelect) {
                mainSelect.value = firstVariantForColor.id;
              }
              if (main) {
                main.value = firstVariantForColor.id;
              }
              window.updateSelection(firstVariantForColor);
            }
          }
        });
      }
    });
  };
  window.attachProductOptionListeners();
  
  window.getSelectedVariant = function() {
    // Re-query selectors in case DOM was updated
    const currentSelectors = document.querySelectorAll("[data-option-selector]");
    selected = [];
  
    for (const selector of currentSelectors) {
      if (selector.hasAttribute('data-option-radio')) {
        if (selector.checked) {
          selected.push(selector.value)
        }
      } else if (selector.hasAttribute('data-option-select')) {
        selected.push(selector.value)
      }
    }
  
    // Get fresh variants JSON
    const currentVariantsJson = getVariantsJson();
    
    if (selected.length === 0) {
      return null;
    }
  
    const selected_title = selected.join(" / ");
    
    let selected_variant = currentVariantsJson.find(e => (e.title == selected_title));
    
    // If not found, try using option1/option2 matching (more reliable)
    if (!selected_variant && selected.length >= 2) {
      selected_variant = currentVariantsJson.find(v => {
        // Try using option1/option2 if available
        if (v.option1 && v.option2) {
          return v.option1 === selected[0] && v.option2 === selected[1];
        }
        // Fallback to title parsing
        const titleParts = v.title.split(' / ');
        return titleParts[0] === selected[0] && titleParts[1] === selected[1];
      });
    }
    
  
  
    return selected_variant;
  }
  
  window.updateSelection = function(selected_variant) {
    const mainSelect = document.querySelector("[data-option-main]");
    if (mainSelect) {
      mainSelect.value = selected_variant.id;
    }
    
    // Also update the cached main variable for backward compatibility
    if (main) {
      main.value = selected_variant.id;
    }

    // Keep PreProduct's native pre-order button in sync with the size/color chosen
    // on the product page, so it pre-orders the selected variant instead of
    // prompting the customer to pick a variant again in its own dropdown.
    try {
      document.querySelectorAll('[data-native-pre-order-btn]').forEach(function (ppBtn) {
        ppBtn.setAttribute('data-starting-variant', selected_variant.id);
      });
    } catch (error) {
    }
  
    // change images - wrap in try-catch so errors don't break the rest
    try {
      updateVariantImages();
    } catch (error) {
    }
  
    // Update size button styles immediately
    if (typeof window.updateSizeButtonStyles === 'function') {
      window.updateSizeButtonStyles();
    }
  
    // update option names - use variant's option properties (option1, option2, option3) which are most reliable
    setTimeout(function() {
      const selectedValuesByPosition = {};
      
      // Use option1, option2, option3 if available (most reliable)
      if (selected_variant.option1) {
        selectedValuesByPosition['1'] = selected_variant.option1;
      }
      if (selected_variant.option2) {
        selectedValuesByPosition['2'] = selected_variant.option2;
      }
      if (selected_variant.option3) {
        selectedValuesByPosition['3'] = selected_variant.option3;
      }
      
      
      if (Object.keys(selectedValuesByPosition).length === 0 && selected_variant.title) {
        const variantTitleParts = selected_variant.title.split(' / ').map(function(part) {
          return part.trim();
        });
        variantTitleParts.forEach(function(part, index) {
          selectedValuesByPosition[(index + 1).toString()] = part;
        });
      }
      
      // Update each option label with the selected value for its position
      document.querySelectorAll('[data-option-label]').forEach(function(optionLabel) {
        const position = optionLabel.getAttribute('data-option-position');
        const optionName = optionLabel.getAttribute('data-option-name');
        const optionTextElement = optionLabel.querySelector('.js-option');
        
        if (position && optionTextElement) {
          const selectedValue = selectedValuesByPosition[position];
          if (selectedValue) {
            optionTextElement.textContent = selectedValue;
          } else {
            // Last resort: try to get from checked radio
            const checkedRadio = document.querySelector('input[type="radio"][data-option-position="' + position + '"]:checked');
            if (checkedRadio) {
              const value = checkedRadio.getAttribute('data-option-value') || checkedRadio.value;
              if (value) {
                optionTextElement.textContent = value;
              }
            }
          }
        }
      });
      
      // Fallback: if no data-option-label elements found, update first .js-option
      if (document.querySelectorAll('[data-option-label]').length === 0) {
        const firstOption = document.querySelector('.js-option');
        if (firstOption) {
          firstOption.textContent = selected_variant.title;
        }
      }
    }, 100); // Increased delay to ensure DOM is fully updated
  
    // update pricing
    const priceEl = document.querySelector(".js-variant-price");
    if (priceEl) priceEl.innerHTML = selected_variant.price;

    const comparePriceEl = document.querySelector(".js-variant-compare-price");
    if (comparePriceEl) comparePriceEl.innerHTML = selected_variant.compare_at_price;
  
    // if not available, let them know
    if (selected_variant.available === true || selected_variant.available === 'true') {
      add_to_cart_button.style.display = "block";
      sold_out.style.display = "none";
    } else {
      add_to_cart_button.style.display = "none";
      sold_out.style.display = "block";
    }
  
    // Update size button styles after variant selection
    // Check if the function exists (it's defined in product.liquid)
    if (typeof window.updateSizeButtonStyles === 'function') {
      // Call immediately to update green border indicator
      window.updateSizeButtonStyles();
      // Call again after a short delay to ensure it catches all updates
      setTimeout(window.updateSizeButtonStyles, 100);
    }
  
  }
  
  // Track if we're currently handling a thumbnail click to prevent updateVariantImages from interfering
  let isThumbnailClickInProgress = false;
  
  function updateVariantImages() {  
    // Don't reset slide if user is clicking thumbnails
    if (isThumbnailClickInProgress) {
      return;
    }
    
    if (!main || !images || images.length === 0) {
      return;
    }
    
    const current_variant_id = main.value;
    const current_images = images.filter(e => (e.variant_id == current_variant_id));
    
    if (current_images.length === 0 || !current_images[0] || !current_images[0].src) {
      return;
    }
    
    // Find the thumbnail that matches the first image and go to that slide
    // BUT: Only do this if the variant actually changed (not on every call)
    const $images = jQuery('.js-images');
    if ($images.hasClass('slick-initialized')) {
      // Check if we're already showing an image from this variant
      const currentSlideIndex = $images.slick('slickCurrentSlide');
      const currentSlideImg = jQuery($images.find('.slick-slide')[currentSlideIndex]).find('img').attr('src');
      const variantFirstImg = current_images[0].src;
      
      // Only change slide if we're not already showing an image from this variant
      if (currentSlideImg !== variantFirstImg) {
        jQuery('.js-thumbnail img').each(function(index) { 
          if ((jQuery(this).attr('src')) == variantFirstImg) { 
            // Go directly to the slide instead of clicking
            // Use false to skip animation (prevents layout shifts)
            $images.slick('slickGoTo', index, false);
            // Only update thumbnail active state if not during initialization
            if (window.thumbnailActiveStateInitialized) {
              updateThumbnailActiveState(index);
            }
            return false; // break the loop
          } 
        });
      }
    }
  }
  
  function updateImages() {
    unsetSlider(); 

    const main = document.querySelector('[data-option-main]');
    if (!main) {
      console.error('updateImages: main select not found');
      return;
    }
    
    const current_variant_id = main.value;
    
    const current_images = images.filter((v,i,a)=>a.findIndex(v2=>(v2.src===v.src))===i);
  
    updateThumbnails(current_images)
    updateMainImages(current_images)

  
    addArrows();

    setSlider();
    constrainHeroContainer();
    setNav();

    revealImageBlock();

    setTimeout(function() {
      window.thumbnailActiveStateInitialized = true;
      initImageZoom();
    }, 300);
  
  }

  function revealImageBlock() {
    const jsBlock = document.querySelector('.js-block');
    if (jsBlock) {
      jsBlock.style.opacity = 1;
    }
  }
  
  function setNav() {
    // Remove any existing handlers first (always remove to ensure clean state)
    jQuery(document).off('click.thumbnailNav', '.js-thumbnail');
    jQuery('.js-thumbnail').off('click.thumbnailNav');
    
    // Use event delegation - works even after DOM updates - use namespaced events
    jQuery(document).on('click.thumbnailNav', '.js-thumbnail', function (e) {
      // Don't prevent default - we want the click to work
      // e.preventDefault();
      // e.stopPropagation();
      
      
      isThumbnailClickInProgress = true;
      
      const $thumb = jQuery(this);
      let slideIndex = $thumb.attr('data-index');
      
      // If data-index is not set, try to get it from the index
      if (slideIndex === undefined || slideIndex === null || slideIndex === '') {
        slideIndex = $thumb.index('.js-thumbnail');
      }
      
      const index = parseInt(slideIndex, 10);
      
      if (isNaN(index) || index < 0) {
        isThumbnailClickInProgress = false;
        return;
      }
      
      const $images = jQuery('.js-images');
      
      if ($images.length === 0) {
        isThumbnailClickInProgress = false;
        return;
      }
      
      const isSlickInitialized = $images.hasClass('slick-initialized');
      if (isSlickInitialized) {
        const slideCount = $images.find('.slick-slide').length;
        
        if (index >= 0 && index < slideCount) {
          const currentSlide = $images.slick('slickCurrentSlide');
          
          if (currentSlide !== index) {
            // Use slickGoTo with animation for fade mode
            $images.slick('slickGoTo', index, true);
            
            // Manually ensure slick-active class is set (Slick sometimes doesn't update it immediately in fade mode)
            setTimeout(function() {
              $images.find('.slick-slide').removeClass('slick-active');
              const targetSlide = $images.find('.slick-slide').eq(index);
              targetSlide.addClass('slick-active');
            }, 10);
          }
          
          // Update thumbnail active state immediately
          updateThumbnailActiveState(index);
          
          // Clear flag after a longer delay to prevent updateVariantImages from interfering
          setTimeout(function() {
            isThumbnailClickInProgress = false;
          }, 2000);
        } else {
          isThumbnailClickInProgress = false;
        }
      } else {
        setTimeout(function() {
          isThumbnailClickInProgress = false;
        }, 100);
      }
    });
    
    // Update active state when slick slider changes (arrow navigation)
    // BUT: Don't interfere if thumbnail click is in progress OR during initialization
    // CRITICAL: Don't attach during setNav() - delay until after slick fully initializes
    // The afterChange event fires during slick initialization, causing layout shifts
    setTimeout(function() {
      jQuery('.js-images').off('afterChange.slick').on('afterChange.slick', function(event, slick, currentSlide) {
        // Only update if not in the middle of a thumbnail click AND slick is fully initialized
        if (!isThumbnailClickInProgress && window.thumbnailActiveStateInitialized) {
          updateThumbnailActiveState(currentSlide);
        }
      });
    }, 200);
    
  }
  
  // Expose on window for instrumentation
  window.updateThumbnailActiveState = function(activeIndex) {
    jQuery('.js-thumbnail').each(function(index) {
      const $thumb = jQuery(this);
      
      if (index === activeIndex) {
        $thumb.addClass('active');
        $thumb.attr('aria-current', 'true');
        const viewport = this.closest('.thumbnail-carousel-viewport');
        if (viewport) {
          const thumbTop = this.offsetTop;
          const thumbBottom = thumbTop + this.offsetHeight;
          const vpTop = viewport.scrollTop;
          const vpBottom = vpTop + viewport.clientHeight;
          if (thumbTop < vpTop || thumbBottom > vpBottom) {
            viewport.scrollTop = thumbTop - 8;
          }
        }
      } else {
        $thumb.removeClass('active');
        $thumb.attr('aria-current', 'false');
      }
    });
    var mobileStrip = document.querySelector('.js-mobile-thumbs');
    if (mobileStrip) {
      mobileStrip.querySelectorAll('.mobile-thumb').forEach(function(t, idx) {
        t.classList.toggle('active', idx === activeIndex);
      });
      var activeThumb = mobileStrip.querySelector('.mobile-thumb.active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  };
  
  function addArrows() {
    const arrowsContainer = document.querySelector('.js-arrows');
    if (!arrowsContainer) {
      return;
    }
    
    let arrows =
      `
      <button class='js-next product-arrow z-20 absolute right-0 top-1/2 transform -translate-y-1/2' aria-label='Next Image'>
        <svg aria-hidden="true" width="14px" height="27px" viewBox="0 0 14 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP_Desktop_Hero_2" transform="translate(-1378.000000, -494.000000)" fill="#000000" fill-rule="nonzero"><g id="Hero1" transform="translate(-1.000000, 208.000000)"><g id="nav-arrows" transform="translate(47.000000, 286.000000)"><g id="Carrot" transform="translate(1339.454545, 13.545455) rotate(-90.000000) translate(-1339.454545, -13.545455) translate(1326.454545, 6.545455)"><polygon id="Path" points="25.0264317 0 12.7136564 11.3033954 0.973568282 0.525739321 0 1.41949617 12.7136564 13.0909091 26 0.893756846"></polygon></g></g></g></g></g></svg>
      </button>
      <button class='js-prev product-arrow z-20 absolute left-0 top-1/2 transform -translate-y-1/2' aria-label='Previous Image'>
        <svg aria-hidden="true" width="15px" height="27px" viewBox="0 0 15 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Homepage---Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="HP_Desktop_Hero_2" transform="translate(-48.000000, -496.000000)" fill="#000000" fill-rule="nonzero"><g id="Hero1" transform="translate(-1.000000, 208.000000)"><g id="nav-arrows" transform="translate(47.000000, 286.000000)"><g id="Carrot" transform="translate(8.545455, 15.128788) rotate(-270.000000) translate(-8.545455, -15.128788) translate(-4.454545, 7.545455)"><polygon id="Path" points="25.0264317 0 12.7136564 12.245345 0.973568282 0.569550931 0 1.53778751 12.7136564 14.1818182 26 0.968236583"></polygon></g></g></g></g></g></svg>
      </button>
      `
  
    arrowsContainer.innerHTML = arrows;
  }
  
  function unsetSlider() {
    if (jQuery('.js-images').hasClass('slick-initialized')) {
      jQuery('.js-images').slick('unslick');
    }
  }
  
  
  function setSlider() {
    jQuery('.js-images').slick({
      dots: (window.innerWidth < 768),
      arrows: true,
      fade: true,
      appendArrows: jQuery('.js-arrows'),
      nextArrow: jQuery('.js-next'),
      prevArrow: jQuery('.js-prev'),
      accessibility: true,
      ariaLive: 'polite'
    });
  }

  function constrainHeroContainer() {
    if (window.innerWidth < 768) return;
    var maxH = window.__productHeroMaxHeight || 0;
    if (!maxH) return;

    var $images = jQuery('.js-images');
    if (!$images.length) return;

    var img = $images.find('.slick-slide.slick-active img')[0] || $images.find('img')[0];
    if (!img) return;

    var apply = function() {
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        var w = Math.round(maxH * img.naturalWidth / img.naturalHeight);
        var mw = w + 'px';
        var $heroWrap = jQuery('.product-hero-wrap');
        if ($heroWrap.length) {
          $heroWrap.css({'max-width': mw, 'margin-left': 'auto', 'margin-right': 'auto'});
        } else {
          $images.css({'max-width': mw, 'margin-left': 'auto', 'margin-right': 'auto'});
        }
        jQuery('.js-arrows').css({'max-width': mw, 'margin-left': 'auto', 'margin-right': 'auto'});
        if ($images.hasClass('slick-initialized')) {
          $images.slick('setPosition');
        }
      }
    };

    if (img.complete) {
      apply();
    } else {
      img.addEventListener('load', apply, { once: true });
    }
  }

  function updateThumbnails(images) {
    if (!images || images.length === 0) {
      return;
    }
  
    // Get aspect ratio from hero image container's rendered dimensions
    const getHeroAspectRatio = function(callback) {
      const $images = jQuery('.js-images');
      const imagesContainer = $images[0];
      
      if (imagesContainer) {
        // Get the rendered dimensions of the images container (not natural image dimensions)
        const getRenderedAspectRatio = function() {
          const rect = imagesContainer.getBoundingClientRect();
          const containerWidth = rect.width;
          const containerHeight = rect.height;
          
          // Also try to get from the active slide's image
          let heroImg = null;
          if ($images.hasClass('slick-initialized')) {
            const activeSlide = $images.find('.slick-slide.slick-active img').first();
            if (activeSlide.length) {
              heroImg = activeSlide[0];
            }
          }
          
          if (!heroImg) {
            heroImg = imagesContainer.querySelector('img');
          }
          
          if (heroImg && heroImg.complete && heroImg.naturalWidth > 0 && heroImg.naturalHeight > 0) {
            const aspectRatio = heroImg.naturalHeight / heroImg.naturalWidth;
            callback(aspectRatio);
          } else if (containerWidth > 0 && containerHeight > 0) {
            const aspectRatio = containerHeight / containerWidth;
            callback(aspectRatio);
          } else if (heroImg) {
            // Wait for image to load
            heroImg.addEventListener('load', function() {
              const aspectRatio = heroImg.naturalHeight / heroImg.naturalWidth;
              callback(aspectRatio);
            }, { once: true });
          } else {
            // Fallback: wait and try again
            setTimeout(function() {
              getRenderedAspectRatio();
            }, 100);
          }
        };
        
        // Try immediately
        getRenderedAspectRatio();
      } else {
        // Fallback: wait a bit and try again
        setTimeout(function() {
          getHeroAspectRatio(callback);
        }, 100);
      }
    };
    
    const createThumbnails = function(aspectRatio) {
      let thumbnail_images_block = '';
  
    if (images) {
        // Calculate thumbnail dimensions based on hero aspect ratio
        // Guard against zero/tiny aspect ratios (container not yet sized)
        const safeAspectRatio = (aspectRatio && aspectRatio > 0.1) ? aspectRatio : 1.25;
        const regularWidth = 57;
        const regularHeight = Math.round(regularWidth * safeAspectRatio) || 71;
        const activeWidth = 100;
        const activeHeight = Math.round(activeWidth * safeAspectRatio) || 125;
        
        window.thumbnailRegularHeight = regularHeight;
        window.thumbnailActiveHeight = activeHeight;
        
        document.documentElement.style.setProperty('--thumbnail-regular-height', regularHeight + 'px');
        document.documentElement.style.setProperty('--thumbnail-active-height', activeHeight + 'px');
        
        const productContainer = document.querySelector('.js-product');
        if (productContainer) {
          productContainer.style.setProperty('--thumbnail-regular-height', regularHeight + 'px');
          productContainer.style.setProperty('--thumbnail-active-height', activeHeight + 'px');
        }

      for (let i = 0; i < images.length; i++) {
        const thumbnail_image = images[i];
        const isActive = i === 0 ? 'active' : '';
          const imageNum = i + 1;
          
          // Calculate Shopify image size (2x for retina)
          const thumbWidth = isActive ? activeWidth * 2 : regularWidth * 2;
          const thumbHeight = isActive ? activeHeight * 2 : regularHeight * 2;
          
          let thumbnailSrc = thumbnail_image.src;
          
          // Convert Shopify image URL to use proper sizing (skip if dimensions are invalid)
          if (thumbnailSrc && thumbnailSrc.includes('shopify.com') && thumbWidth > 0 && thumbHeight > 0) {
            try {
              // Remove existing size parameters
              thumbnailSrc = thumbnailSrc.replace(/_[0-9]+x[0-9]+\./g, '.');
              thumbnailSrc = thumbnailSrc.replace(/\?v=[0-9]+/g, '');
              
              // Add size based on calculated dimensions
              thumbnailSrc = thumbnailSrc.replace(/\.(jpg|jpeg|png|webp)/i, '_' + thumbWidth + 'x' + thumbHeight + '.$1');
            } catch (e) {
              console.error('Error processing thumbnail URL:', e, 'Original src:', thumbnail_image.src);
            }
          }
          
          // Ensure we have a valid src
          if (!thumbnailSrc || thumbnailSrc.trim() === '') {
            thumbnailSrc = thumbnail_image.src || '';
          }
          
          // Don't apply inline styles - let CSS variables handle it
        let thumbnail_image_block = `
          <div class='product-thumbnail ${isActive} relative js-thumbnail cursor-pointer' data-index='${i}' style='margin-bottom: 16px;' role='button' tabindex='0' aria-label='View image ${imageNum}'>
            <img src='${thumbnailSrc}' alt='${(thumbnail_image.alt || "Product thumbnail " + imageNum).replace(/'/g, "&#39;")}' class='w-full h-full' loading='lazy' style='object-fit: cover; image-rendering: -webkit-optimize-contrast;'>
        </div>
      `
          thumbnail_images_block += thumbnail_image_block;
        }
      }
      
      const thumbnailsContainer = document.querySelector('.js-thumbnails');
      if (thumbnailsContainer) {
        const regHeight = window.thumbnailRegularHeight || 71;
        const actHeight = window.thumbnailActiveHeight || 125;
        
        // Also set CSS variables on the thumbnails container for inheritance
        thumbnailsContainer.style.setProperty('--thumbnail-regular-height', regHeight + 'px');
        thumbnailsContainer.style.setProperty('--thumbnail-active-height', actHeight + 'px');
        
        thumbnailsContainer.innerHTML = thumbnail_images_block;
        
        
        const thumbs = thumbnailsContainer.querySelectorAll('.product-thumbnail');
        thumbs.forEach(function(thumb) {
          thumb.style.setProperty('pointer-events', 'auto', 'important');
          thumb.style.setProperty('cursor', 'pointer', 'important');
          thumb.style.setProperty('z-index', '1', 'important');
        });
        
        if (typeof window.initThumbnailCarousel === 'function') {
          setTimeout(window.initThumbnailCarousel, 150);
        }
      }
    };
    
    // Get hero aspect ratio first, then create thumbnails
    getHeroAspectRatio(createThumbnails);
  }
  
  function updateMainImages(images) {
    let main_images_block = ''
  
    if (images) {
      for (let main_image of images) {
        let main_image_block = `
          <div>
            <div class='js-zoomx zoom-image'>
              <img class='block w-full' src='${main_image.src}' alt='${(main_image.alt || "Product image " + (images.indexOf(main_image) + 1)).replace(/'/g, "&#39;")}' />
            </div>
          </div>
        `
        main_images_block += main_image_block
      }
    }
  
    document.querySelector('.js-images').innerHTML = main_images_block;
  }

  function initImageZoom() {
    if (typeof ImageZoom === 'undefined') return;
    if (window.innerWidth < 768) return;

    killImageZoom();

    var options = {
      fillContainer: true,
      zoomPosition: 'original'
    };

    var zoom_images = document.querySelectorAll('.js-zoomx, .zoom-image');
    var zoom_array = [];

    for (var i = 0; i < zoom_images.length; i++) {
      var inst = new ImageZoom(zoom_images[i], options);
      zoom_array.push(inst);
    }

    window['imagezoom'] = zoom_array;

    if (!window._imageZoomResizeHandler) {
      var resizeTimer;
      window._imageZoomResizeHandler = function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          initImageZoom();
        }, 300);
      };
      window.addEventListener('resize', window._imageZoomResizeHandler);
    }
  }

  function killImageZoom() {
    var zoom_images = window['imagezoom'];
    if (zoom_images) {
      for (var i = 0; i < zoom_images.length; i++) {
        if (zoom_images[i] && zoom_images[i].kill) {
          try { zoom_images[i].kill(); } catch(e) {}
        }
      }
    }
    window['imagezoom'] = [];
  }

(async () => {
  // Load images
  images = await getProductImages()

  // Update display
  updateImages()
  updateVariantImages()
})()




// function getFeaturedImages() {
//   let product = JSON.parse(document.querySelector('.js-product-json').innerHTML)
//   let variants = product.variants
//   let images = product.images

//   let featured_images = []

//   for (let variant of variants) {
//     if (variant.featured_image) {
//       let obj = {
//         src: variant.featured_image.src,
//         variant_id: variant.featured_image.variant_ids[0],
//       }
//       featured_images.push(obj)
//     }
//   }


//   if (featured_images.length == 0) {
//     return [];
//   }


//   let new_images = {}
//   let variant_id = ''

//   for (let image of images) {
//     for (let featured_image of featured_images) {
//       let featured_image_without_https = featured_image['src'].replace('https:', '')
//       if (featured_image_without_https == image) {
//         variant_id = featured_image.variant_id
//       }
//     }

//     if (new_images[variant_id] == undefined) {
//       new_images[variant_id] = []
//     }
//     new_images[variant_id].push(image)
//   }  

//   return new_images;
// }

// function getImages() {
//   let product = JSON.parse(document.querySelector('.js-product-json').innerHTML)
//   return product.images
